import React, { ChangeEvent, useEffect, useState } from 'react'
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CButton,
  CCol,
  CRow,
  CFormInput,
} from '@coreui/react-pro'
import { notification } from 'antd'
import { $error, addTickets, addTicketsSubmit } from './model'
import { NotificationPlacement } from 'antd/es/notification/interface'
import { useUnit } from 'effector-react'

type Props = {
  isVisible: boolean
  onClose: () => void
}

export const AddTicketsModal: React.FC<Props> = ({ isVisible, onClose }) => {
  const [dataTickets, setDataTickets] = useState<{
    ticketID?: number
    userID?: number
  }>({})

  const [api, contextHolder] = notification.useNotification()

  const saveError = useUnit($error)

  addTickets.doneData.watch((result) => {
    if (result) {
      onClose()
    }
  })

  const openNotification = (placement: NotificationPlacement) => {
    api.error({
      message: `Error`,
      description: `${saveError.message}`,
      placement,
    })
  }

  useEffect(() => {
    if (saveError.code !== 0) {
      openNotification('topRight')
    }
  }, [saveError])

  const handleChange = (event: {
    currentTarget: { name: any; value: any }
  }) => {
    const { name, value } = event.currentTarget // сохраняем локально
    setDataTickets((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  return (
    <CModal visible={isVisible} onClose={onClose}>
      {contextHolder}
      <CModalHeader>
        <CModalTitle>Add tickets</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CRow className="mb-3">
          <CCol sm={6}>
            <CFormInput
              type="text"
              name="ticketID"
              placeholder="ticketID"
              label="ticketID"
              value={dataTickets.ticketID}
              onChange={handleChange}
            />
          </CCol>
          <CCol sm={6}>
            <CFormInput
              type="text"
              name="userID"
              placeholder="userID"
              label="userID"
              value={dataTickets.userID}
              onChange={handleChange}
            />
          </CCol>
        </CRow>
        <CButton
          className="float-lg-end"
          onClick={() => addTicketsSubmit(dataTickets)}
        >
          Submit
        </CButton>
      </CModalBody>
    </CModal>
  )
}
